import { IOnboardingChecklistFileField } from "entities/Deal/sdk";

import { GuessedConnectionAutocompleteConstantOptions } from "./constants";

export const extractCustomFieldPaths = ({
  data,
}: {
  data: Array<IOnboardingChecklistFileField>;
}) => {
  const result: Array<{ value: number; label: string }> = [
    {
      value: 0,
      label: GuessedConnectionAutocompleteConstantOptions.LEAVE_UNMATCHED,
    },
    {
      value: -1,
      label: GuessedConnectionAutocompleteConstantOptions.MARK_AS_NA,
    },
    ...data.map((field) => ({
      value: field.id,
      label: field.name,
    })),
  ];

  return result;
};
